import {APP_INITIALIZER, ErrorHandler, LOCALE_ID, NgModule} from '@angular/core';
import {registerLocaleData} from '@angular/common';
import {ModeratRoutingModule} from "./moderat-routing.module";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MAT_DATE_LOCALE} from "@angular/material/core";
import {BrowserModule} from "@angular/platform-browser";
import {HttpClient, provideHttpClient, withInterceptorsFromDi} from "@angular/common/http";
import * as Sentry from "@sentry/angular";
import {Router} from "@angular/router";
import localeDE from "@angular/common/locales/de";
import {ModeratComponent} from "./moderat.component";
import {EinstiegComponent} from "./einstieg/einstieg.component";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {VerbrauchsanalyseStartComponent} from "./verbrauchsanalyse/verbrauchsanalyse.start.component";
import {StepService} from "../services/step.service";
import {AdvisorSharedModule} from "../advisor.shared.module";
import {VerbrauchsanalyseStepComponent} from "./verbrauchsanalyse/verbrauchsanalyse.step.component";
import {BestandsaufnahmeStartComponent} from "./bestandsaufnahme/bestandsaufnahme.start.component";
import {BestandsaufnahmeStepComponent} from "./bestandsaufnahme/bestandsaufnahme.step.component";
import {VerbrauchsanalyseErgebnisComponent} from "./verbrauchsanalyse/verbrauchsanalyse.ergebnis.component";
import {SanierungComponent} from "./sanierung/sanierung.component";
import {MatExpansionModule} from "@angular/material/expansion";
import { SanierungMeasureComponent } from './sanierung/sanierung-measure.component';
import { SanierungInvestComponent } from './sanierung/sanierung-invest.component';
import { SanierungCo2Component } from './sanierung/sanierung-co2.component';
import { SanierungInvestRowComponent } from './sanierung/sanierung-invest-row.component';
import {MatSliderModule} from "@angular/material/slider";
import {MatSlideToggleModule} from "@angular/material/slide-toggle";
import { SanierungEconomicComponent } from './sanierung/sanierung-economic.component';
import { SanierungCo2costsComponent } from './sanierung/sanierung-co2costs.component';
import {SanierungIntroductionComponent} from "./sanierung/sanierung-introduction.component";
import {TranslateFakeLoader, TranslateLoader, TranslateModule} from "@ngx-translate/core";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {PortalService} from "../services/portal.service";
import {VerbrauchsanalyseModeratStepVerbrauchsdatenComponent} from "./verbrauchsanalyse/verbrauchsanalyse-moderat.step.verbrauchsdaten.component";
import {AdvisorVerbrauchsanalyseModule} from "../advisor.verbrauchsanalyse.module";
import {VerbrauchsanalyseModeratAusstiegComponent} from "./verbrauchsanalyse/verbrauchsanalyse-moderat.ausstieg.component";
import {WpcheckStartComponent} from './wpcheck/wpcheck.start.component';
import {ExternalEntryComponent} from "./external-entry/external-entry.component";
import {AdvisorEnergyMapModule} from '../advisor.energy.map.module';
import {ModeratEnergyMapComponent} from './energy-map/moderat.energy.map.component';
import {ModeratEnergyMapDonatedComponent} from './energy-map/moderat.energy.map.donated.component';

// global definition of language prefixe
declare let advisorTranslationPrefix;

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  if(document?.location?.host === 'localhost:4201') {
    // workaround for sowing only the textkeys in testing environment
    return new TranslateFakeLoader();
  }
  return new TranslateHttpLoader(http, (typeof advisorTranslationPrefix !== "undefined"? advisorTranslationPrefix : "translations/" + PortalService.defaultPortal + "/moderat/"), ".json");
}

// load the locales dynamic, based on the users browser language with fallback
let browserLocale = getBrowsersLocale();
switch(browserLocale.substring(0,2)) {
  case 'de':
    registerLocaleData(localeDE, 'de');
    break;
}

/**
 * returns the users locale from the browser
 *
 * @returns {any}
 */
function getBrowsersLocale() {
  return 'de-DE';
}

@NgModule({
    declarations: [ModeratComponent, EinstiegComponent, VerbrauchsanalyseStartComponent, VerbrauchsanalyseModeratStepVerbrauchsdatenComponent,
        VerbrauchsanalyseStepComponent, VerbrauchsanalyseErgebnisComponent, VerbrauchsanalyseModeratAusstiegComponent,
        BestandsaufnahmeStartComponent, BestandsaufnahmeStepComponent, SanierungComponent, SanierungMeasureComponent,
        SanierungInvestComponent, SanierungCo2Component, SanierungInvestRowComponent, SanierungEconomicComponent, SanierungCo2costsComponent, SanierungIntroductionComponent,
        WpcheckStartComponent,
        ExternalEntryComponent,
        ModeratEnergyMapComponent,
        ModeratEnergyMapDonatedComponent
    ],
    bootstrap: [
        ModeratComponent
    ],
  imports: [
    BrowserModule,
        TranslateModule.forRoot({
            loader: {provide: TranslateLoader, useFactory: HttpLoaderFactory, deps: [HttpClient]}
        }),
        ModeratRoutingModule,
        ReactiveFormsModule,
        FormsModule,
        MatCheckboxModule,
        MatExpansionModule,
        MatSliderModule,
        MatSlideToggleModule,
        AdvisorSharedModule,
        AdvisorVerbrauchsanalyseModule,
        AdvisorEnergyMapModule
    ],
  providers: [
    {provide: MAT_DATE_LOCALE, useValue: 'de-DE'},
    {provide: LOCALE_ID, useValue: getBrowsersLocale()},
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
        dialogOptions: {
          user: {
            name: 'dummy',
            email: 'dummy@co2online.de'
          }
        }
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
    StepService,
        provideHttpClient(withInterceptorsFromDi())
  ]
})
export class ModeratModule {}
